import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M7.358 19.358a8 8 0 0 0 8.465 1.833l.269-.1a2 2 0 0 0 .712-3.287l-1.39-1.39a2 2 0 0 0-2.828 0l-.672.672a2 2 0 0 1-2.828 0l-2.172-2.172a2 2 0 0 1 0-2.828l.672-.672a2 2 0 0 0 0-2.828l-1.39-1.39a2 2 0 0 0-3.286.712l-.101.269a8 8 0 0 0 1.834 8.465z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12.293 11.707a1 1 0 0 1 0-1.414L16.586 6H13a1 1 0 1 1 0-2h6a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V7.414l-4.293 4.293a1 1 0 0 1-1.414 0",
      clipRule: "evenodd"
    }
  )
);
var SvgAnsweredOutboundFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var AnsweredOutboundFilled_default = SvgAnsweredOutboundFilled;

export { AnsweredOutboundFilled_default as default };
